function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInbound = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.373,
    height: 10.958,
    viewBox: "0 0 12.373 10.958",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1188"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20794",
    d: "M9.2 0H0",
    transform: "translate(2.675 5.249)",
    style: {
      strokeLinecap: "round",
      fill: "none",
      stroke: "#5167fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20792",
    d: "m-18419.41-3850.792-2.418-2.415 2.418-2.414",
    transform: "translate(18424.504 3858.526)",
    style: {
      strokeLinejoin: "round",
      strokeLinecap: "round",
      fill: "none",
      stroke: "#5167fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20793",
    d: "M-18424.59-3852.131v-2.682h-7.082v9.958h7.082v-2.574",
    transform: "translate(18432.172 3855.313)",
    style: {
      strokeLinejoin: "round",
      fill: "none",
      stroke: "#5167fd"
    }
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInbound, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Inbound.76a4be6c.svg";
export { ForwardRef as ReactComponent };